import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class InrixService {

  private _BEARER_TOKEN: string = 'Bearer ';
  private _token: string;
  private inrixSubject = new Subject<any>();

  private _urlTilesApi = environment.urlTilesInrix; //'http://192.168.0.96/tiles/TilesService.asmx/GetTile?options=';
  private _urlRoutingApi = 'http://eu.api.inrix.com/Traffic/Inrix.ashx';
  private _urlProxy = 'http://localhost:4200/infotransit/assets/Inrix.json'; //*/ window.location.protocol + '//' + window.location.hostname +  '/infotransit/assets/Inrix.json';
  
  private paramOpacity = "90";
  private paramRoadsegmenttype = "XDS";
  

  // GET / SET ---------------------------------------------------------------
  public get BEARER_TOKEN(): string { return this._BEARER_TOKEN; }
  public set BEARER_TOKEN(value: string) { this._BEARER_TOKEN = value; }
  public get token(): string { return this._token; }
  public set token(value: string) { this._token = value; }
  public get urlTilesApi() { return this._urlTilesApi; }
  public set urlTilesApi(value) { this._urlTilesApi = value; }
  public get urlRoutingApi() { return this._urlRoutingApi; }
  public set urlRoutingApi(value) { this._urlRoutingApi = value; }
  public get urlProxy() { return this._urlProxy; }
  public set urlProxy(value) { this._urlProxy = value; }

  constructor() {   }
  
  getInrixService() {
    this.inrixSubject.next();
  }

  getTokenObservable(): Observable<any> {
    return this.inrixSubject.asObservable();
  }

  /**
   * Retorna la url amb els paràmetres necessaris per aconseguir una tile donat un punt, un zoom i un centre
   */
  getTileUrl(tile: google.maps.Point, zoom: number, center: string, trafficMode: string, date: string): string {

    let url = this.urlTilesApi
      + this.getQuadKey(tile, zoom)
      + "?coverage=255" // 255="Total Fusion (TM)" - i.e. light up every road we can / 8 = Real-time core + extended coverage. ;
      + "&format=png" // we have a good browser, give us PNGs for better quality
      + "&layers=T" // just give us the traffic tile layer
      + "&penWidth=" + ((zoom / 4 * 3) + 1) // make the pen width adjustable based on zoom
      + "&opacity=" + this.paramOpacity
      + "&frcLevel=1,2" + (zoom > 10 ? (zoom > 11 ? ",3,4,5" : ",3") : "");
      + "&roadsegmenttype=" + this.paramRoadsegmenttype;
      if (trafficMode === 'Trànsit en previsió') url += '&starttime=' + date;

    return url;
  }

  /**
   * Retorna la url amb els paràmetres necessaris per aconseguir una ruta
   * @param waypoints 
   */
  getFastestPathUrl(waypoints: string[]) {
    var url: string;
    url = this.urlRoutingApi + "?Action=FindRoute"
      + "&Units=1"
      + "&MaxAlternates=0"
      + "&UseTraffic=true"
      + "&RouteOutputFields=S,P,B";
    for (var i = 0; i < waypoints.length; i++) {
      url += '&wp_' + (i + 1).toString() + '=' + waypoints[i];
    }


    return url + "&Token=" + this.token + "&format=json";
  }


  /**
   * Calculem el quadKey des de les coordenades x, y i el zoom
   * @param tile google.maps.Point tile.x and tile.y
   * @param zoom zoom map
   */
  getQuadKey(tile: google.maps.Point, zoom: number): string {
    var quadKey: string = '';

    for (let i = zoom; i > 0; i--) {
      let digit = 0;
      let mask = 1 << (i - 1);

      if ((tile.x & mask) != 0) {
        digit++;
      }

      if ((tile.y & mask) != 0) {
        digit++;
        digit++;
      }

      quadKey += digit;
    }

    return quadKey;
  }

}
